import { useCallback, useRef, useState } from 'react';
import { submitOnce } from './dialogs/ShipmentDialog.helpers';

/**
 * PGSS-5572: run a slow submit once at a time, and say when it is running so the button can be
 * disabled for the whole request. See submitOnce.
 *
 * @returns {[boolean, function(function(): Promise): Promise<boolean>]} [busy, run]
 */
export default function useSubmitOnce() {
  const inFlight = useRef(false);
  const [busy, setBusy] = useState(false);
  const run = useCallback((task) => submitOnce(inFlight, task, setBusy), []);

  return [busy, run];
}
